// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1FhB2","inputWrap":"Table_inputWrap__3jQBW","col":"Table_col__25HWr","bmiTooltip":"Table_bmiTooltip__1AYyJ"};